import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';

import { setReferral, setClickId } from 'cityads-v3/actions/auth';

export class AuthReferralSetter extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.any.isRequired,

    uid         : PropTypes.string,
    isSettingUid: PropTypes.bool,
    isUidSet    : PropTypes.bool,

    clickId         : PropTypes.string,
    clickIdReferral : PropTypes.string,
    clickIdEnot     : PropTypes.string,
    isSettingClickId: PropTypes.bool,
    isClickIdSet    : PropTypes.bool,
  };

  updateUid(parsedLocation) {
    const { dispatch, uid, isSettingUid, isUidSet } = this.props;

    const locationUid = parsedLocation.uid || null;

    if (locationUid && (locationUid !== uid || (!isUidSet && !isSettingUid))) {
      dispatch(setReferral(locationUid));
    }
  }

  updateClickId(parsedLocation) {
    const { dispatch, clickId, clickIdReferral, clickIdEnot } = this.props;

    const locationRef = parsedLocation.ref || null;
    const locationClickId = parsedLocation.click_id || null;
    const locationEnot = parsedLocation.enot || null;

    if (
      locationRef && locationClickId &&
      (
        locationRef !== clickIdReferral ||
        locationClickId !== clickId ||
        locationEnot !== clickIdEnot
      )
    ) {
      dispatch(setClickId(locationRef, locationClickId, locationEnot));
    }
  }

  componentDidMount() {
    const parsedLocation = queryString.parse(this.props.location.search);

    this.updateUid(parsedLocation);
    this.updateClickId(parsedLocation);
  }

  componentDidUpdate(prevProps) {
    const parsedLocation = queryString.parse(this.props.location.search);

    this.updateUid(parsedLocation);
    this.updateClickId(parsedLocation);
  }

  render() {
    return null;
  }
}

export default compose(
  withRouter,
  connect(
    state => ({
      uid         : state.auth.referralUid,
      isSettingUid: state.auth.referralUidSetting,
      isUidSet    : state.auth.referralUidSet,

      clickId         : state.auth.clickId,
      clickIdReferral : state.auth.clickIdReferral,
      clickIdEnot     : state.auth.clickIdEnot,
      isSettingClickId: state.auth.clickIdSetting,
      isClickIdSet    : state.auth.clickIdSet,
    })
  )
)(AuthReferralSetter);
